// External modules
import React from 'react';
import { isEmpty } from 'lodash';

// Internal modules
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import Modal from '@material-ui/core/Modal';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import moment from 'moment-timezone';
import axios from 'axios';

import ACButton from '../../atoms/ACButton';
import styles from './SetUser.module.scss';
import config from '../../../config/config';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import CircularProgress from '@material-ui/core/CircularProgress';

const userAPIURL = config.userAPIURL;
const signUpURL = config.signUpURL;
const realm = config.realm;


export default class SetUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openDialog: false,
      userEmail:'',
      userPassword:'',
      saveDisabled:true,
      isValidEmail:false,
      isValidPassword:false,
    };

    this.onClickDialogClose = this.onClickDialogClose.bind(this);
    this.onSaveUser = this.onSaveUser.bind(this);
    this.validatorFunction= this.validatorFunction.bind(this);
    this.validateEmail=this.validateEmail.bind(this);
    this.onChangeEmailText=this.onChangeEmailText.bind(this);
    this.onChangePasswordText=this.onChangePasswordText.bind(this);
    this.postProviderLinkedUser=this.postProviderLinkedUser.bind(this);
  }

  onClickDialogClose() {
    this.setState({
      openDialog: false,
    });
  }

  onChangeEmailText(event){
    this.setState({
      userEmail:(event.target.value).trim()
    })
    this.validateEmail((event.target.value).trim());
  }

   async postProviderLinkedUser(values){
    // TODO: Ask username properly
    const username = `arc-${moment().unix()}`;
    // TODO: In Redux please
    try {
        await axios
            .post(signUpURL, {
                email: values.email,
                password: values.password,
                username,
                connection: realm,
            })
            .then((signUpResponse) => {
                console.log('signUpResponse', signUpResponse);
                // Update AmazingCo user data
                const postUserURL = `${userAPIURL}/api/v1/users`;
                const data = {
                    appMetadata:values.appMetadata,
                    detail: {
                      providerId:values.providerId
                    },
                    emailAddress: values.email,
                    password: values.password,
                };
                if (signUpResponse && signUpResponse.data && signUpResponse.data._id) {
                    data.auth0Id = `auth0|${signUpResponse.data._id}`;
                }
                try {
                    axios
                        .post(postUserURL, data)
                        .then((postUserResponse) => {
                            if (postUserResponse && postUserResponse.data && postUserResponse.data.data) {
                                console.log('postUserResponse.data.data', postUserResponse);
                                  this.props.getProviderLinkedUsersFunc(values.providerId);

                                return postUserResponse
                            } else {
                                console.log('Failed posting user, Response:', postUserResponse);
                            }
                        })
                        .catch((error) => {
                            alert('Failed posting user, please check your input again!');
                            console.log('Failed posting user, Error:', error);
                        });
                } catch (error) {
                    alert('Failed posting user, please check your input again!');
                    console.log('Failed posting user, Error:', error);
                }
            })
            .catch((error) => {
                alert('Failed signing up, please check your input again!');
                console.log('Failed posting user, Error:', error);
            });
    } catch (error) {
        alert('Failed signing up, please check your input again!');
        console.log('Failed signing up, Error:', error);
    }

    this.props.onCloseFunc();
  }

  renderProgressDialog = () => {
    return (
      <div>
        <Dialog open={this.state.isSaving} aria-labelledby="draggable-dialog-title">
          <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
            Please wait...
          </DialogTitle>
          <DialogContent>
            <center>
              <CircularProgress />
            </center>
          </DialogContent>
        </Dialog>
      </div>
    );
  };

  onChangePasswordText(event){
    this.setState({
      userPassword:(event.target.value).trim()

    })
    this.checkPasswordLength((event.target.value).trim())
    }

  async onSaveUser(){
    const { userEmail, userPassword } = this.state;
    const userObject = {
      email:userEmail,
      password:userPassword,
      providerId:this.props.provider.id,
      appMetadata :{
        actions: [],
        environment: {},
        objects: [],
        subject: {
            types: ['provider'],
        },
        },
        secret:'amazing123',
    }
    await this.postProviderLinkedUser(userObject);
    this.props.onCloseFunc();
  
  }

  validateEmail=(email)=>{
    const { users } = this.props;
    const regexPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // regex pattern for email validation
    let isValidEmailRegex = regexPattern.test(email);
    let ValidEmail =true;
    if(!isEmpty(users)){
      
      users.map((user)=>{
       if(user.email_address === email ){
        ValidEmail= false
       }
       return true
      });
     }
    this.setState({
      isValidEmail :(isValidEmailRegex && ValidEmail)?true:false
      })

  }

   validatorFunction =()=>{
    const { isValidEmail, isValidPassword } = this.state;
     this.setState({
       saveDisabled:(isValidEmail && isValidPassword)?false:true
     })
  }

  checkPasswordLength = (password) => {
    const isValid = password.trim().length>8;
    if(isValid){
      this.setState({
        isValidPassword:true
      })
    }
  };

  render() {
    const {isValidEmail , isValidPassword} = this.state;
    return (
      <div>
        <Modal open={this.props.isModifyingUser} onClose={this.props.onCloseFunc}>
          <div className={styles.root}>
            <div>
              <div className={styles.fullWidthColumn}>
                <div className={styles.top}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    {/* <h3>Add User</h3> */}
                  </div>
                  <div>
                    <CloseIcon className={styles.pointerCursor} onClick={this.props.onCloseFunc} />
                  </div>
                </div>
                <div className={styles.middle}>
                  <div>
                    <div
                      style={{
                        marginTop: '20px',
                      }}
                    >
                      <TextField
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start" className={styles.adornment}>
                              Email
                            </InputAdornment>
                          ),
                        }}
                        className={styles.textField}
                        value={this.state.userEmail}
                        onChange={(e) => this.onChangeEmailText(e)}
                        placeholder="User Email"
                      />
                    </div>
                    <div
                      style={{
                        marginTop: '20px',
                        display: 'flex',
                        flexDirection: 'row',
                      }}
                    >
                      <TextField
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start" className={styles.adornment}>
                              Password
                            </InputAdornment>
                          ),
                        }}
                        className={styles.textField}
                        value={this.state.userPassword}
                        onChange={(e) => this.onChangePasswordText(e)}
                        placeholder="Password"
                      />
                    </div>
                    <div
                      style={{
                        marginTop: '20px',
                        fontSize:'12px'
                      }}
                    >Minimum of 8 characters in length</div>
                  </div>
                </div>
                <div className={styles.bottom}>
                  <ACButton
                    text={'Save'}
                    icon={<SaveIcon />}
                    iconLast={true}
                    onClickFunc={this.onSaveUser}
                    color={(isValidEmail && isValidPassword)?'#52A8EF':"#616161"}
                    disabled={(isValidEmail && isValidPassword)?false:true}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal>
        {this.renderProgressDialog()}
      </div>
    );
  }
}
